// 변수 업데이트
function XChangeData(e, setData) {
//   console.log("XChangeData");
  setData((state) => {
    return { ...state, [e.target.name]: e.target.value };
  });
}
export default XChangeData;
